/*
 * ╔══════════════════════════════════════════════════════════════════════════╗
 * ║ MAVZU — STANDART HOLAT OQ, QORONG'ISI IXTIYORIY                         ║
 * ║                                                                          ║
 * ║ EGASINING TALABI: «ekran hozir dark turibdi, oq qil».                    ║
 * ║                                                                          ║
 * ║ Ilgari mavzuni Windows tanlardi (`prefers-color-scheme`) va ilovada uni  ║
 * ║ o'zgartiradigan hech narsa yo'q edi — ya'ni tizimi qorong'i turgan odam  ║
 * ║ ERP ni HECH QACHON oq holda ko'ra olmasdi.                               ║
 * ║                                                                          ║
 * ║ Endi uch holat emas, IKKI holat bor: `light` va `dark`. «Tizimga ergash» ║
 * ║ ataylab yo'q — u aynan hozirgi muammoni qaytarib olib kelardi va         ║
 * ║ «nega ekranim boshqa rangda?» degan savolga javob berish qiyin bo'lardi. ║
 * ║ Tanlov aniq: foydalanuvchi nimani bossa, o'sha turadi.                   ║
 * ╚══════════════════════════════════════════════════════════════════════════╝
 */

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'evo.theme';

/**
 * Standart mavzu. `dark` EMAS va tizim sozlamasi ham SO'RALMAYDI —
 * yuqoridagi ramkaga qarang.
 */
export const DEFAULT_THEME: Theme = 'light';

export function readTheme(): Theme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : DEFAULT_THEME;
  } catch {
    /*
     * `localStorage` maxfiylik rejimida va ba'zi korporativ siyosatlarda
     * OTADI (o'qishda ham). Mavzu — bezak, ya'ni u ilovani yiqitmasligi
     * kerak: xato yutiladi va standart holat qaytariladi.
     */
    return DEFAULT_THEME;
  }
}

export function applyTheme(theme: Theme): void {
  /*
   * `light` da atribut QO'YILMAYDI, olib tashlanadi.
   *
   * `data-theme="light"` yozish ham ishlardi, lekin o'shanda CSS da ikkita
   * shart bo'lardi. Hozir qoida bitta va u o'qishga oson:
   * atribut bor = qorong'i, yo'q = oq.
   */
  if (theme === 'dark') {
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }
}

export function saveTheme(theme: Theme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Saqlanmasa ham joriy sessiyada ishlaydi — yuqoridagi izohga qarang.
  }
}

/**
 * React ilova ko'tarilishidan OLDIN chaqiriladi (`main.tsx`).
 *
 * Sabab — «miltillash» (FOUC): agar mavzu `useEffect` ichida qo'yilsa,
 * birinchi kadr oq chizilib, keyin qorong'iga sakrardi. Bu ayniqsa sekin
 * mashinada ko'zga tashlanadi.
 */
export function initTheme(): Theme {
  const theme = readTheme();
  applyTheme(theme);
  return theme;
}
